import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { ActionHandlerFunction, ApproversInfo, AGUserInfo, ApproversList } from "@preveil-api";
import { PublicRoutes, isSameUser, ExpressResetPasswordUIActionTypes } from "src/common";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  user_info: AGUserInfo;
  approvers_list: ApproversList;
  handleAction: ActionHandlerFunction;
}

function RecoveryPanel(props: AllProps) {
  const { handleAction, user_info, approvers_list } = props;
  const approvers: ApproversInfo[] = approvers_list.approvers;
  const approved_count = approvers.filter(approver => approver.approved).length;

  // Description: Build approvers rows (optionals and required)
  function ApproverRows() {
    return _.map(approvers, (approver: ApproversInfo, i: number) => {
      return !isSameUser(approver.user_id, user_info.user_id) &&
        <li key={`approver_${i}`} className={approver.approved ? "text-muted" : ""}>
          <div>
            <h2>{approver.display_name} </h2>
            <p>{approver.user_id}</p>
            {
              approver.required && <span className="text-danger fs-5">*required</span>
            }
          </div>
          {
            approver.approved ?
              < Icon className="icon ficon-user-check text-success" /> :
              <Button variant="outline-secondary"
                onClick={() => handleAction({
                  actionType: ExpressResetPasswordUIActionTypes.GetShard,
                  params: approver
                })} >
                Start
              </Button>}
        </li >;
    });
  }

  return <>
    <p className="fs-4 border-bottom pb-3">You have received approval
      from <b>{approved_count}</b> of <b>{approvers_list.optionals_required}</b> required group members.</p>
    <ul className="recovery-options">
      {ApproverRows()}
    </ul>
    <div className="btn-panel text-end mt-3">
        <Button onClick={() => handleAction({ actionType: ExpressResetPasswordUIActionTypes.ReconstructUserKey })}
        disabled={approved_count < approvers_list.optionals_required}>Reset Password</Button>
      <Link className="btn btn-outline-primary" to={`/${PublicRoutes.get_started_route}`}>Cancel</Link>
    </div>
  </>;
}

export default React.memo(RecoveryPanel);
